import { render } from "./MySkills.vue?vue&type=template&id=15ae98a6&scoped=true"
import script from "./MySkills.vue?vue&type=script&lang=js"
export * from "./MySkills.vue?vue&type=script&lang=js"

import "./MySkills.vue?vue&type=style&index=0&id=15ae98a6&scoped=true&lang=scss"

import exportComponent from "/srv/http/cv.mzubiaga.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ae98a6"]])

export default __exports__